import { Component, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { ToastModule } from 'primeng/toast'
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { PrimeNG, PrimeNGConfigType } from 'primeng/config'

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, TranslateModule, FontAwesomeModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    library: FaIconLibrary,
    private config: PrimeNG,
    private translateService: TranslateService
  ) {
    library.addIconPacks(fas)
  }

  ngOnInit() {
    this.translateService.setDefaultLang('fr')
    this.translateService.use('fr')

    // Configurer les traductions françaises pour PrimeNG
    this.translateService.get('primeng').subscribe((res) => {
      if (res) {
        this.config.setTranslation(res)
      }
    })
  }
}
